// This is the "common" entry-point for webpack
// It should include all common, shared and vendor resources to be webpack-ed, that are not specific to this app.

// Include required Font Awesome 5 resources for iconography

// SVG Version:
// Depends: @fortawesome/fontawesome
// Optional: @fortawesome/fontawesome-free-brands @fortawesome/fontawesome-free-regular @fortawesome/fontawesome-free-solid
// require('./font-awesome-svg')

// Web Font Version - works better for Pseudo Elements:
// Free ones:
// require('./sass/font-awesome-webfonts.scss')
// Pro Fonts
require("@fortawesome/fontawesome-pro/css/light.css");
require("@fortawesome/fontawesome-pro/css/brands.css");
require("@fortawesome/fontawesome-pro/css/fontawesome.css");

// Which set of core static resources to load based on layout
require('./layouts/precedent')

// JavaScript core support for "Precedent" page style elements
require('./js/precedent.js')

// Add Import/Require lines for additional modules, including KendoUI, etc...
// See doc/client.md for more details and examples!
import 'jquery-ui/themes/base/sortable.css'
require('jquery-ui/ui/widgets/sortable')
import 'jsgrid/css/jsgrid.css'
import 'jsgrid/css/theme.css'
require('jsgrid')

require('form-serializer')

require('bootstrap-validator/js/validator.js')

import 'kendo-ui-core/css/web/kendo.common-material.css'
import 'kendo-ui-core/css/web/kendo.material.css'
require('kendo-ui-core/js/kendo.autocomplete')
require('kendo-ui-core/js/kendo.dialog')
require('kendo-ui-core/js/kendo.notification')
require('kendo-ui-core/js/kendo.sortable')

// require('kendo-ui-core/js/kendo.core')
// require('kendo-ui-core/js/kendo.ui.core')

module.exports = exports = {
   // Hook to allow triggering actions on page load
   onDocumentReady: (callback) => { $(document).ready(callback) },
   jQuery
}
